import { useMutation } from '@tanstack/react-query'
import { resendSignUpCode } from 'aws-amplify/auth'

import { sendEvent } from 'src/shared/api/events/send-event'

export const useConsumerResendCode = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      // Using email as username for consumer accounts
      const result = await resendSignUpCode({ username: email })

      sendEvent({
        eventType: 'auth_consumer_resend_code',
        info: { email },
      })
      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      console.error('Resend code error:', errorName, errorMessage)

      sendEvent({
        eventType: 'auth_consumer_resend_code_error',
        info: { error: errorName, message: errorMessage },
      })
    },
  })
}
